import { eventsApiSlice } from '../../../store/eventApiSlice';

export const extendedApiSlice = eventsApiSlice
  .enhanceEndpoints({
    addTagTypes: ['RDO::User', 'RDO::organiser-details', 'RDO::event-details'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      managerLogin: builder.mutation({
        query: ({ username, password }) => {
          const formData = new FormData();
          formData.append('username', username.trim());
          formData.append('password', password);
          return {
            url: 'auth/compliance-manager/login',
            method: 'POST',
            data: formData,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          };
        },
        invalidatesTags: ['RDO::User'],
      }),

      getEventTypesForRDO: builder.query({
        query: () => ({
          url: 'compliance/manager/event-types',
        }),
      }),

      getOrganiserDetailsForRDO: builder.query({
        query: (organiser_id) => ({
          url: `compliance/manager/organiser-details/${organiser_id}`,
        }),
        providesTags: ['RDO::organiser-details'],
      }),

      getOrganiserDetailsForAdmin: builder.query({
        query: (organiser_id) => ({
          url: `compliance/organiser-details/${organiser_id}/one-click`,
        }),
        providesTags: ['RDO::organiser-details'],
      }),

      updateEventTypeApprovalStatus: builder.mutation({
        query: ({ organiser_id, event_type_id, status }) => ({
          url: 'compliance/manager/event-type-approval-status',
          method: 'PUT',
          data: { organiser_id, event_type_id, status },
        }),
        invalidatesTags: ['RDO::organiser-details'],
      }),

      updateVolunteerApprovalStatus: builder.mutation({
        query: ({ organiser_id, submission_id, status }) => ({
          url: 'compliance/volunteer-agreement/admin-approval',
          method: 'PUT',
          data: { organiser_id, submission_id, status },
        }),
        invalidatesTags: ['RDO::organiser-details'],
      }),
      updateCoachApprovalStatus: builder.mutation({
        query: ({ status }) => ({
          url: 'compliance/coach/confirm-access',
          method: 'POST',
          data: { status },
        }),
        invalidatesTags: ['RDO::organiser-details'],
      }),

      getEventDetailsForRDO: builder.query({
        query: (event_id) => ({
          url: `compliance/manager/event-details/${event_id}`,
        }),
        providesTags: ['RDO::event-details'],
      }),

      updateRLWApprovalStatus: builder.mutation({
        query: ({ event_id, status }) => ({
          url: 'compliance/manager/rlw-approval-status',
          method: 'PUT',
          data: { event_id, status },
        }),
        invalidatesTags: ['RDO::event-details'],
      }),
      getComplianceAdminStatistics: builder.query({
        query: ({ start, end }) => ({
          url: `compliance/manager/statistics-full?start=${start}&end=${end}`,
        }),
      }),
    }),
  });

export const {
  useGetEventTypesForRDOQuery,
  useGetOrganiserDetailsForRDOQuery,
  useGetOrganiserDetailsForAdminQuery,
  useUpdateEventTypeApprovalStatusMutation,
  useUpdateVolunteerApprovalStatusMutation,
  useUpdateCoachApprovalStatusMutation,
  useGetEventDetailsForRDOQuery,
  useUpdateRLWApprovalStatusMutation,
  useGetComplianceAdminStatisticsQuery,
  useManagerLoginMutation,
} = extendedApiSlice;
